import { createSlice } from "@reduxjs/toolkit";

export interface AuthState {
  authenticated: boolean;
}

const initialState: AuthState = {
  authenticated: false
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    update: (state, action) => {
      const { authenticated } = action.payload;
      state.authenticated = authenticated;
    },
  },
});

export const { update } = authSlice.actions;
export default authSlice.reducer;
